export const editMatchedLocationHeader =
  'Only contact info for this location can be edited here.'

export const editMatchedLocationUpdateHeader =
  'You can edit the contact information for this existing PestPac account below. Updates will be reflected in PestPac upon saving.'
